import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, filter } from 'rxjs';
import { Segment } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class SegmentListService {
  public segmentList = signal<Segment[]>([]);
  public updateSegmentPayload = new BehaviorSubject<Segment | null>(null);
  public updateSegment$ = this.updateSegmentPayload
    .asObservable()
    .pipe(filter(Boolean));
}
